import React from 'react';
import Icon from '../atoms/Icon';

function SpeedometerIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 32 27">
      <g 
        fill='currentColor' 
        fillRule='nonzero'
      >
        <path d='M15.8181 18.4546C17.2741 18.4546 18.4545 17.2742 18.4545 15.8182C18.4545 14.3622 17.2741 13.1818 15.8181 13.1818C14.3621 13.1818 13.1818 14.3622 13.1818 15.8182C13.1818 17.2742 14.3621 18.4546 15.8181 18.4546Z'/>
        <path d='M26.3637 17.1364C27.0917 17.1364 27.6818 16.5462 27.6818 15.8182C27.6818 15.0902 27.0917 14.5 26.3637 14.5C25.6356 14.5 25.0455 15.0902 25.0455 15.8182C25.0455 16.5462 25.6356 17.1364 26.3637 17.1364Z'/>
        <path d='M5.27277 17.1364C6.00078 17.1364 6.59095 16.5462 6.59095 15.8182C6.59095 15.0902 6.00078 14.5 5.27277 14.5C4.54476 14.5 3.95459 15.0902 3.95459 15.8182C3.95459 16.5462 4.54476 17.1364 5.27277 17.1364Z'/>
        <path d='M6.68586 22.4091C7.41387 22.4091 8.00404 21.8189 8.00404 21.0909C8.00404 20.3629 7.41387 19.7727 6.68586 19.7727C5.95785 19.7727 5.36768 20.3629 5.36768 21.0909C5.36768 21.8189 5.95785 22.4091 6.68586 22.4091Z'/>
        <path d='M6.68586 11.8636C7.41387 11.8636 8.00404 11.2735 8.00404 10.5454C8.00404 9.81743 7.41387 9.22726 6.68586 9.22726C5.95785 9.22726 5.36768 9.81743 5.36768 10.5454C5.36768 11.2735 5.95785 11.8636 6.68586 11.8636Z'/>
        <path d='M24.9506 22.4091C25.6786 22.4091 26.2687 21.8189 26.2687 21.0909C26.2687 20.3629 25.6786 19.7727 24.9506 19.7727C24.2226 19.7727 23.6324 20.3629 23.6324 21.0909C23.6324 21.8189 24.2226 22.4091 24.9506 22.4091Z'/>
        <path d='M10.5455 8.00398C11.2735 8.00398 11.8637 7.41381 11.8637 6.6858C11.8637 5.95778 11.2735 5.36761 10.5455 5.36761C9.81747 5.36761 9.22729 5.95778 9.22729 6.6858C9.22729 7.41381 9.81747 8.00398 10.5455 8.00398Z'/>
        <path d='M15.8182 6.59092C16.5462 6.59092 17.1364 6.00075 17.1364 5.27274C17.1364 4.54473 16.5462 3.95456 15.8182 3.95456C15.0902 3.95456 14.5 4.54473 14.5 5.27274C14.5 6.00075 15.0902 6.59092 15.8182 6.59092Z'/>
        <path d='M21.0909 8.00398C21.8189 8.00398 22.4091 7.41381 22.4091 6.6858C22.4091 5.95778 21.8189 5.36761 21.0909 5.36761C20.3629 5.36761 19.7727 5.95778 19.7727 6.6858C19.7727 7.41381 20.3629 8.00398 21.0909 8.00398Z'/>
      </g>

      <g 
        fill='none' 
        stroke='currentColor'
        stroke-width='2.63636'
        stroke-miterlimit='10'
      >
        <path d='M15.8182 15.8182L25.2669 10.4189'/>
        <path d='M27.003 25.0454C29.0738 22.5383 30.3182 19.3232 30.3182 15.8182C30.3182 7.81022 23.8261 1.31818 15.8182 1.31818C7.81022 1.31818 1.31818 7.81022 1.31818 15.8182C1.31818 19.3232 2.56254 22.5383 4.6334 25.0454H27.003Z'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(SpeedometerIcon);
